function adjustCtaBannerPaddingForElements() {
    // Get all elements with class 'overlapping-inset-banner-section'
    const bannerSections = document.querySelectorAll('.overlapping-inset-banner-section');
    
    bannerSections.forEach(bannerSection => {
        const bannerHeight = bannerSection.offsetHeight / 2;

        let previousElement = bannerSection.previousElementSibling;
        let nextElement = bannerSection.nextElementSibling;

        // Find the previous element with padding
        while (previousElement && previousElement.tagName.toLowerCase() === 'style') {
            previousElement = previousElement.previousElementSibling;
        }
        let previousElementWithPadding = findCtaBannerElementOrChildWithPadding(previousElement);

        // Find the next element with padding
        while (nextElement && nextElement.tagName.toLowerCase() === 'style') {
            nextElement = nextElement.nextElementSibling;
        }
        let nextElementWithPadding = findCtaBannerElementOrChildWithPadding(nextElement);

        // Adjust padding bottom for the previous element
        if (previousElementWithPadding) {
            const previousPaddingBottom = parseInt(window.getComputedStyle(previousElementWithPadding).paddingBottom);
            previousElementWithPadding.style.paddingBottom = (previousPaddingBottom + bannerHeight) + 'px';
        }

        // Adjust padding top for the next element
        if (nextElementWithPadding) {
            const nextPaddingTop = parseInt(window.getComputedStyle(nextElementWithPadding).paddingTop);
            nextElementWithPadding.style.paddingTop = (nextPaddingTop + bannerHeight) + 'px';
        }
    });
}

// Helper function to find the element or its first child with padding
function findCtaBannerElementOrChildWithPadding(element) {
    if (!element) return null;

    if (hasCtaBannerPadding(element)) {
        return element;
    }

    return findCtaBannerFirstChildWithPadding(element);
}

// Helper function to check if an element has padding
function hasCtaBannerPadding(element) {
    const computedStyle = window.getComputedStyle(element);
    return (
        parseInt(computedStyle.paddingTop) > 0 ||
        parseInt(computedStyle.paddingRight) > 0 ||
        parseInt(computedStyle.paddingBottom) > 0 ||
        parseInt(computedStyle.paddingLeft) > 0
    );
}

// Helper function to recursively find the first child with padding
function findCtaBannerFirstChildWithPadding(element) {
    if (!element) return null;

    for (let child of element.children) {
        if (hasCtaBannerPadding(child)) {
            return child;
        } else {
            const nestedChild = findCtaBannerFirstChildWithPadding(child);
            if (nestedChild) return nestedChild;
        }
    }
    return null;
}

adjustCtaBannerPaddingForElements();